import type {
  Customer,
  CustomerInput,
  CustomerListParams,
  CustomerListResult,
} from '../types'
import { customerRepository, CustomerRepository } from './customer-repository'

/**
 * CustomerService — application use-cases for customers module.
 */
export class CustomerService {
  private readonly repository: CustomerRepository

  constructor(repository: CustomerRepository = customerRepository) {
    this.repository = repository
  }

  list(params: CustomerListParams): CustomerListResult {
    return this.repository.query(params)
  }

  getById(id: string): Customer | null {
    return this.repository.findById(id)
  }

  create(input: CustomerInput): Customer {
    return this.repository.create(input)
  }

  update(id: string, input: Partial<CustomerInput>): Customer {
    return this.repository.update(id, input)
  }

  remove(id: string): Customer {
    return this.repository.softDelete(id)
  }

  duplicate(id: string): Customer {
    return this.repository.duplicate(id)
  }

  listCities(): string[] {
    return [...new Set(this.repository.listAll().map((c) => c.cidade).filter(Boolean) as string[])].sort(
      (a, b) => a.localeCompare(b, 'pt-BR'),
    )
  }
}

export const customerService = new CustomerService()
